let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("aKJlN")).then(() => parcelRequire('3nacu'));